export const siteInfo = {
  name: '成91',
  fullName: '成91官方平台',
  description: '成91是备受用户关注的热门综合服务平台，致力于为用户提供优质、便捷的在线服务体验。',
  founded: '2019',
  users: '500万+',
  satisfaction: '98.7%',
  awards: '15+',
  contact: {
    email: 'service@cheng91.com',
    phone: '400-xxx-xxxx',
    address: '中国',
    workingHours: '周一至周日 9:00 - 22:00',
  },
  reputation: [
    { label: '累计注册用户', value: '500万+' },
    { label: '日均活跃用户', value: '80万+' },
    { label: '用户满意度', value: '98.7%' },
    { label: '行业奖项', value: '15+' },
  ],
  milestones: [
    { year: '2019', event: '成91平台正式上线运营' },
    { year: '2020', event: '注册用户突破100万' },
    { year: '2021', event: '推出会员服务体系' },
    { year: '2022', event: '平台功能全面升级' },
    { year: '2023', event: '注册用户突破300万' },
    { year: '2024', event: '获得行业最佳平台奖' },
    { year: '2025', event: '注册用户突破500万' },
    { year: '2026', event: '平台全新改版，体验升级' },
  ],
};